import { Components } from "@mui/material/styles";

export const MuiFormControlLabel: Components['MuiFormControlLabel'] = {
    defaultProps: {
        labelPlacement: 'end'
    },
    styleOverrides: {
        root: {
            '& .MuiTypography-root': {
                fontFamily: "Roboto",
                fontSize: "14px",
                color: "#152935",
                letterSpacing: "0",
                lineHeight: "18px",
                fontWeight: 500,
                textAlign: "left"
            }
        }
    }
}